export const isValidRecipePostCard = ({ attributes }: TContent): boolean => !!attributes?.link;
